import { gql } from '@apollo/client'
export const KLARNA_UPDATE_SESSION = gql`
    query KlarnaSessionUpdate($attachment: String!, $cartId: String!) {
        klarnaSessionUpdate(attachment:  $attachment, cartId: $cartId)
    }
`
